{
  "id": "campaign-109",
  "name": "Untamed Promenade",
  "seed": "campaign:109",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "x.,,,,ACCA,,,,,x",
    "..,%,,,CC,,,%,,,",
    "..,,,,,CC,,,,,,,",
    "w+wwwww++wwwww+w",
    "w+wwwww++wwwww+w",
    ",,,,,~,CC,,,,,,,",
    ",,,,t,~CC,,t,,,,",
    ",,X,,,CCCC,,,X,x",
    "CCCCCCCOOCCCCCCC",
    ",,,,,,CCCC.,,,,,",
    ",,,,,,,CC...,,,,",
    "x,,,Y,,CC..Y,,,x",
    ",,,,,,,CC...,,,,",
    ",,,,,,,CC..,,,,,",
    ",,,,,,.CC...,,,,",
    "..,x,.....x.,,..",
    "S...,...x......."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 11,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 6,
      "y": 15
    },
    {
      "kind": "squirrel",
      "x": 14,
      "y": 15
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 1
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 9,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 5,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 0
    },
    {
      "kind": "gas",
      "x": 5,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 11
    },
    {
      "kind": "repair",
      "x": 13,
      "y": 2
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "falls": [
    {
      "x": 2,
      "y": 7,
      "dir": "E",
      "at": 35,
      "length": 3
    },
    {
      "x": 13,
      "y": 7,
      "dir": "W",
      "at": 41,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 109,
  "biome": "estate",
  "par": {
    "reel": 8276,
    "push": 7115,
    "selfPropelled": 6474,
    "tractor": 5396,
    "zeroTurn": 4596,
    "fairway": 3074
  },
  "goldTime": {
    "reel": 8276,
    "push": 7115,
    "selfPropelled": 6474,
    "tractor": 5396,
    "zeroTurn": 4596,
    "fairway": 3031
  },
  "routeTries": {
    "par": {
      "reel": 14,
      "push": 14,
      "selfPropelled": 4,
      "tractor": 4,
      "zeroTurn": 4,
      "fairway": 13
    },
    "gold": {
      "reel": 14,
      "push": 14,
      "selfPropelled": 4,
      "tractor": 4,
      "zeroTurn": 4,
      "fairway": 26
    }
  }
}
